import { Tabs, TabsList, TabsTrigger } from "app/shadcnComponents/ui/tabs";

interface ArchivedTabSelectorProps {
  availableTabs: {
    label: string;
    count?: number;
  }[];
  selectedTab: string;
  onTabChange: (tab: string) => void;
}

const ArchivedTabSelector = ({
  availableTabs,
  selectedTab,
  onTabChange,
}: Readonly<ArchivedTabSelectorProps>) => {
  return (
    <div>
      <Tabs value={selectedTab} onValueChange={onTabChange}>
        <TabsList>
          {availableTabs.map((tab) => (
            <TabsTrigger key={tab.label} value={tab.label}>
              {tab.label}
              {tab.count && <span>({tab.count})</span>}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>
    </div>
  );
};

export default ArchivedTabSelector;
